import React from "react";
import {CustomRule, PatternRule, RequiredRule, StringLengthRule, Validator} from "devextreme-react/validator";

import {LLBtn, LLInput} from "../../../elements";
import {trans} from "../../../../common/utils";
import {CountdownTimer} from "../../../../common/hooks";

const ForgotPassPartTwo = ({commonInputProps, form, setForm, errors, setErrors, forgotPassSubmit, smsTimer, canGetNewOne, setGetNewOne}) => {
    return <div className="forgot-password__part-one">
        <LLInput
            {...commonInputProps}
            label={trans('SMS Code')}
            id="sign-up__code"
            name="sign-up__code"
            minLength={4}
            maxLength={4}
            value={form.code}
            onValueChanged={(e) => {
                setForm((v) => ({
                    ...v,
                    code: e.value,
                }));
                setErrors((v) => ({
                    ...v,
                    code: '',
                }));
            }}
        >
            <Validator>
                <PatternRule
                    message={trans(
                        'The code must contain digits only.'
                    )}
                    pattern={'^[0-9]+$'}
                />
                <RequiredRule message={trans('CODE_EMPTY')}/>
                <StringLengthRule
                    message={trans(
                        'The code must be exactly four digits.'
                    )}
                    min={4}
                    max={4}
                />
                <CustomRule
                    message={trans(errors.code)}
                    validationCallback={() => !errors.code}
                />
            </Validator>
        </LLInput>
        <div className="simple-forgot-password__code-timer-part">
            {!canGetNewOne ? <span className="simple-forgot-password__text">{trans("You can try again in")}: {CountdownTimer({
                    sec: smsTimer ?? 180, onOver: () => {
                        setGetNewOne(true);
                    }
                })}</span>
                :
                <LLBtn
                    className="ll-btn--inline"
                    useSubmitBehavior={false}
                    onClick={() => {
                        forgotPassSubmit(true);
                    }}
                >
                    <div>
                        <span>{trans('Resend code')}</span>
                    </div>
                </LLBtn>}
        </div>
    </div>
};

export default ForgotPassPartTwo;

